import {
  PriceType,
  type Product,
  ProductType,
} from '@wix/ambassador-forms-v4-form/types';
import { generateUUID } from '@wix/form-schema';

import { type ProductValue } from '../../field-settings/settings-shared/products/types';

export function toProductValue(
  product: Product,
  value: number | string,
): ProductValue {
  return {
    productId: product.id!,
    price: value,
    quantity: 1,
  };
}

export function aDynamicPricePayment(
  id: string = generateUUID(),
  min: string | number = 1,
  max?: string | number | null,
): Product {
  return {
    id,
    priceType: PriceType.DYNAMIC_PRICE,
    productType: ProductType.DIGITAL,
    quantityLimit: { minimum: 1, maximum: 1 },
    dynamicPriceOptions: {
      minPrice: String(min),
      maxPrice: max ? String(max) : undefined,
    },
  };
}
